module.exports = __webpack_public_path__ + "static/generate-step-2-4bde3d8212c6072962924db0865154b3.svg";